import { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Floating scroll to top button with smooth animations
 * Exact replica of portfolio design, adapted to Finanzly's orange branding
 */
const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <style>{`
        .scroll-to-top-finanzly {
          position: fixed !important;
          bottom: 1.75rem !important;
          right: 2.44rem !important;
          width: 50px !important;
          height: 50px !important;
          min-width: 50px !important;
          min-height: 50px !important;
          max-width: 50px !important;
          max-height: 50px !important;
          background: #EA580C !important;
          border: none !important;
          border-radius: 50% !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          cursor: pointer !important;
          opacity: 0;
          visibility: hidden;
          transform: translateY(20px);
          transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1),
                      visibility 0.4s cubic-bezier(0.4, 0, 0.2, 1),
                      transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
                      background 0.4s cubic-bezier(0.4, 0, 0.2, 1),
                      box-shadow 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
          z-index: 9997 !important;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
          outline: none !important;
          padding: 0 !important;
          margin: 0 !important;
        }

        .scroll-to-top-finanzly.visible {
          opacity: 1 !important;
          visibility: visible !important;
          transform: translateY(0) !important;
        }

        .scroll-to-top-finanzly.visible:hover {
          background: #F97316 !important;
          transform: translateY(-3px) !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
        }

        .scroll-to-top-finanzly.visible:active {
          transform: translateY(-1px) !important;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
        }

        .scroll-to-top-finanzly .arrow-icon {
          color: #ffffff !important;
          transition: transform 0.3s ease !important;
          flex-shrink: 0 !important;
        }

        .scroll-to-top-finanzly:hover .arrow-icon {
          transform: translateY(-2px) !important;
        }

        @media (max-width: 768px) {
          .scroll-to-top-finanzly {
            width: 44px !important;
            height: 44px !important;
            min-width: 44px !important;
            min-height: 44px !important;
            max-width: 44px !important;
            max-height: 44px !important;
            bottom: 1.25rem !important;
            right: 1.875rem !important;
          }
        }
      `}</style>
      <button
        onClick={scrollToTop}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`scroll-to-top-finanzly ${isVisible ? 'visible' : ''}`}
        aria-label="Volver arriba"
      >
        <ArrowUp 
          className="arrow-icon" 
          size={24} 
          strokeWidth={2.5}
        />
      </button>
    </>
  );
};

export default ScrollToTopButton;